

import templateRegisterPage from '@/app-template/lib/pages/RegisterPage.vue';

export default {
  name: "RegisterPage",
  components: { templateRegisterPage },
};
